import { createSelector } from '@ngrx/store';
import { locationsState } from '../root';

export const hasLocations = createSelector(locationsState, (locations) => !locations?.isDownloading && locations?.data?.length > 0);
